import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useAuth, useIsPlatformAdmin } from '@/providers/AuthProvider';
import { useTenant } from '@/providers/TenantProvider';

/**
 * Ensures tenant context for tenant-scoped routes.
 * VOICERA_ADMIN without an active tenant may browse /platform/*;
 * other tenant routes redirect them to the platform dashboard.
 */
export function RequireTenant() {
  const { isAuthenticated, isLoading } = useAuth();
  const { hasTenant } = useTenant();
  const isPlatformAdmin = useIsPlatformAdmin();
  const location = useLocation();

  if (isLoading) {
    return (
      <div className="flex min-h-screen items-center justify-center text-muted-foreground">
        Loading…
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  const isPlatformRoute = location.pathname.startsWith('/platform');
  const isAccountRoute = location.pathname.startsWith('/settings');
  const isPlatformCallsRoute = location.pathname.startsWith('/calls');

  if (!hasTenant) {
    if (isPlatformAdmin && (isPlatformRoute || isAccountRoute || isPlatformCallsRoute)) {
      return <Outlet />;
    }
    if (isPlatformAdmin) {
      return <Navigate to="/platform/dashboard" replace />;
    }
    return <Navigate to="/login" replace />;
  }

  return <Outlet />;
}
